export const Roles = {
    ADMIN: 'admin',
    BETA_USER: 'beta_user',
    BETA_OWNER: 'beta_owner',
    SUPER_ADMIN: 'super_admin',
}

